// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PFixEntitlementProductDocumentRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_PRODUCT_DOCUMENT_REQ, fieldSet);
    }
    getProductId() {
        return this.getFieldValue(FieldsFactory.FIELD_PRODUCT_ID);
    }
    setProductId(value) {
        this.setFieldValue(FieldsFactory.FIELD_PRODUCT_ID, value);
    }
}
